// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__lgFgn","noInteraction":"EventWrapper_noInteraction__2a11e","pointerPassthrough":"EventWrapper_pointerPassthrough__2hhS6"};